import {browserHistory} from 'react-router';
import UserActionsEnums from './UserActionsEnums'
// WS
import UserService from '../../services/UserService';
// Utils
import {deleteCookie} from '../../utils/CookieUtils';
// Enum
import COOKIES from '../../enums/CookieEnum';
import PAGES from '../../enums/PageEnum';
import ReactGA from 'react-ga';

const getUserDataSuccess = (userData) => ({
    type: UserActionsEnums.USER_GET_INFO_SUCCESS,
    userData
});

export const redirectUserLoginAction = () => {
    deleteCookie(COOKIES.SID);
    browserHistory.push(PAGES.LOGIN_PAGE);
    return (dispatch) => dispatch({type: UserActionsEnums.USER_CLEAN});
};

export const getUserDataAction = () => {
    return (dispatch) => {
        dispatch({type: UserActionsEnums.USER_GET_INFO});
        UserService.getUserInformation()
            .then((userData) => {
                if (UserService.isUserDataValid(userData)) {
                    ReactGA.set(UserService.getGoogleAnalyticsCustomInfo(userData));
                    dispatch(getUserDataSuccess(userData));
                } else {
                    dispatch(redirectUserLoginAction());
                }
            })
            .catch((err) => {
                dispatch(redirectUserLoginAction())
            });
    }
};

export const setBasicDataUser = (userData) => {
    return (dispatch) => dispatch({
        type: UserActionsEnums.USER_SET_BASIC_INFO,
        userData
    });
};



// WEBPACK FOOTER //
// ./src/store/user/UserActions.js